export const HOME_ROUTE = '/cp';
export const WELCOME_ROUTE = '/cp/welcome';
export const DEFAULT_ROUTE = '/cp/classes';
